import { useEffect, useRef } from 'react';
import type { TrackingBuffer } from '../lib/trackingBuffer.js';

export function usePageViewTracking(
  userId: string | undefined,
  sessionId: string | null,
  currentPath: string,
  buffer: TrackingBuffer,
  recordNavigationDuration: (durationMs: number) => void,
): void {
  const lastPathRef = useRef<string | null>(null);
  const lastAtRef = useRef<number>(Date.now());

  useEffect(() => {
    if (!userId || !sessionId) return;
    const previousPath = lastPathRef.current;
    const now = Date.now();
    if (previousPath && previousPath !== currentPath) {
      recordNavigationDuration(now - lastAtRef.current);
    }
    lastAtRef.current = now;
    lastPathRef.current = currentPath;
    buffer.enqueue({
      type: 'track-page-view',
      payload: {
        sessionId,
        pagePath: currentPath,
        referrer: previousPath ?? document.referrer ?? null,
      },
    });
  }, [buffer, currentPath, recordNavigationDuration, sessionId, userId]);
}
